import styled from 'styled-components';
import { COLOR_CV_6, COLOR_WHITE } from 'constants/colors';
import { Collapse } from 'UI';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${COLOR_WHITE};
  padding: 1.5rem;
`;

export const PaymentCollapse = styled(Collapse)`
  &.ant-collapse > .ant-collapse-item > .ant-collapse-header {
    padding-left: 1rem;
    padding-right: 0;
    padding-top: 2.25rem;
    padding-bottom: 0.75rem;
    font-size: 1rem;
    font-weight: 700;
    color: ${COLOR_CV_6};
  }

  & .ant-collapse {
    &-content-box {
      padding: 0;
    }
  }
`;
